import request from "./httpService";
const UPLOAD_ENDPOINT = '/upload';

const upload = (files, onUploadProgress) => {
    return request({
        method: "POST",
        url: `${UPLOAD_ENDPOINT}/new`,
        data: files
    },
    (uploadProgress) => {
        onUploadProgress(uploadProgress)
    });
}

const uploadEmailTemplateImage = (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);

    return request({
        method: 'POST',
        url: `${UPLOAD_ENDPOINT}/email-template-image`,
        data: formData
    },
    (uploadProgress) => {
        if (onUploadProgress) {
            onUploadProgress(uploadProgress)
        }
    });
}

const deleteAttachment = (rowid) => {
    return request({
        method: "DELETE",
        url: `${UPLOAD_ENDPOINT}`,
        params: {rowid: rowid}
    });
}

const getAttachment = (fortable, withid) => {

    return request({
        method: "GET",
        url: `${UPLOAD_ENDPOINT}/${fortable}/${withid}`,
    });
}


export const AttachmentService = {
    upload,
    uploadEmailTemplateImage,
    deleteAttachment,
    getAttachment
};